<template>

  <div class="code-block">

    <v-layout class="code-toolbar">
      <v-spacer></v-spacer>

      <v-flex shrink style="position: relative;">

      <v-slide-y-reverse-transition
      mode="out-in">
        <div v-if="copied" class="tooltip">
          <v-icon>file_copy</v-icon>
          Copied
        </div>
      </v-slide-y-reverse-transition>
      
      <v-btn 
      @click="copyTestingCode" 
      icon
      class="ma-0">
      <v-icon 
      small
      :class="{'anim-iconnnn': copied}">file_copy</v-icon>
      </v-btn>

      <!-- 
      <transition mode="in-out" name="text">
        <span v-if="copied" class="copied-text">Copied</span>
      </transition>
      -->
      

      </v-flex>
    </v-layout>

    <slot></slot>
  </div>

</template>

<script>
export default {
  data () {
    return {
      text: '',
      copied: false
    }
  },
  methods: {
    copyTestingCode () {
      this.text = this.$slots.default[0].text.trim()
      this.$clipboard(this.text)
      this.copied = true
      setTimeout(() => {
        this.copied = false
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.code-block {
  background: #182334;
  background: #f3f6f8;
  padding: 10px;
  border: 0px solid rgba(0,0,0,0.2);
  border-radius: 4px;
  position: relative;
  margin: 10px 0px;
  font-family: Source Code Pro,Fira Code,menlo,monospace;
  font-size: 1rem;
}
.code-block:hover {
  /* box-shadow: 0px 1px 5px #00B0FF; */
}
.anim-icon {
  animation-name: anim;
  animation-duration: 0.2s;
  animation-iteration-count: 2;
  animation-direction: alternate;
  animation-timing-function: ease-in-out;
}
@keyframes anim {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.5);
    color: #00B0FF;
  }
}
.copied-text {
  position: absolute; 
  top: 0px;
}
.text-enter-active, .text-leave-active {
  transition: all 1s ease;
}
.text-enter-to, .text-leave {
  transform: translateY(-120%) scale(1);
}
.text-enter, .text-leave-to {
  transform: translateY(0%) scale(0);
  opacity: 0;
}

.tooltip {
  position: absolute;
  background: #00d200;
  display: flex;
  color: #fff;
  padding: 5px;
  border-radius: 4px;
  z-index: 1;
  right: 0;
  top: -30px;
  align-items: center;
  box-shadow: 0px 1px 3px rgba(0,0,0,0.1);

  & i {
    color: #fff;
  }
}
.code-toolbar {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
